import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "ticketino-api-client";
import { useLanguage } from "../hooks/useLanguage";
import { useOrder } from "../hooks/useOrder";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";

import Image1 from "../images/home_img_1.png";
import Image2 from "../images/home_img_2.png";
import Image3 from "../images/home_img_3.png";
import Image4 from "../images/home_img_4.png";


const Home = () => {
    const [resources, setResources] = useState({});

    const { language } = useLanguage();

    const navigate = useNavigate();
    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    const order = useOrder(baseUrl);

    useEffect(() => {
        loadToken();

        // clear the addedPromocodes in the session
        let array = [];
        localStorage.setItem("AddedPromotions", JSON.stringify(array));
        document.body.classList.remove('no-scroll');
    }, []);

    useEffect(() => {
        requestResources();
    }, [language]);


    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            localStorage.setItem("token", res.data);

            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            /*setPosId(res.data.posId);*/

        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const onSubmit = async () => {
        console.log("")
    };

    return (
        <>
            <Header language={language} pagePath="home" pageTitle={resources?.HomeTitle}
                ticketCount={order?.tickets?.length || 0} />

            <div className="page-container">

                <div className="container">

                    <div className="row">

                        {/* Kindergeburtstage */}
                        <div className="col-12 col-lg-3 text-center">
                            <img
                                src={Image1}
                                className="img-fluid w-100"
                                alt="Kindergeburtstage"
                                style={{ objectFit: "cover", width: "300px", height: "230px" }}
                            />
                            <div className="d-flex flex-column home-description-container">
                                <span className="mt-4"><b>{resources?.HomeBirthday}</b></span>
                                <span className="mt-2">{resources?.HomeBirthdayDesc}</span>
                            </div>
                            <div className="mt-2">
                                <button className="btn-custom white" onClick={() => onSubmit()}>{resources?.HomeFindOutMore}</button>
                            </div>
                            <div className="mt-5 mb-4">
                                <button className="btn-custom" onClick={() => navigate(`/${language}/tickets/birthday`)}>{resources?._Book}</button>
                            </div>
                        </div>

                        {/* Schulgruppen */}
                        <div className="col-12 col-lg-3 text-center">
                            <img
                                src={Image2}
                                className="img-fluid w-100"
                                alt="Schulgruppen"
                                style={{ objectFit: "cover", width: "300px", height: "230px" }}
                            />
                            <div className="d-flex flex-column home-description-container">
                                <span className="mt-4"><b>{resources?.HomeSchoolGroup}</b></span>
                                <span className="mt-2">{resources?.HomeSchoolGroupDesc}</span>
                            </div>
                            <div className="mt-2">
                                <button className="btn-custom white" onClick={() => onSubmit()}>{resources?.HomeFindOutMore}</button>
                            </div>
                            <div className="mt-5 mb-4">
                                <button className="btn-custom" onClick={() => navigate(`/${language}/tickets/schoolgroup`)}>{resources?._Book}</button>
                            </div>
                        </div>

                        {/* Gruppenbesuch */}
                        <div className="col-12 col-lg-3 text-center">
                            <img
                                src={Image3}
                                className="img-fluid w-100"
                                alt="Gruppenbesuch"
                                style={{ objectFit: "cover", width: "300px", height: "230px" }}
                            />
                            <div className="d-flex flex-column home-description-container">
                                <span className="mt-4"><b>{resources?.HomeGroupVisit}</b></span>
                                <span className="mt-2">{resources?.HomeGroupVisitDesc}</span>
                            </div>
                            <div className="mt-2">
                                <button className="btn-custom white" onClick={() => onSubmit()}>{resources?.HomeFindOutMore}</button>
                            </div>
                            <div className="mt-5 mb-4">
                                <button className="btn-custom" onClick={() => navigate(`/${language}/tickets/groupvisit`)}>{resources?._Book}</button>
                            </div>
                        </div>

                        {/* Eventmiete */}
                        <div className="col-12 col-lg-3 text-center">
                            <img
                                src={Image4}
                                className="img-fluid w-100"
                                alt="Eventmiete"
                                style={{ objectFit: "cover", width: "300px", height: "230px" }}
                            />
                            <div className="d-flex flex-column home-description-container">
                                <span className="mt-4"><b>{resources?.HomeEventRental}</b></span>
                                <span className="mt-2">{resources?.HomeEventRentalDesc}</span>
                            </div>
                            <div className="mt-2">
                                <button className="btn-custom white" onClick={() => onSubmit()}>{resources?.HomeFindOutMore}</button>
                            </div>
                            <div className="mt-5 mb-4">
                                <button className="btn-custom" onClick={() => onSubmit()}>{resources?.HomeOfferRequest}</button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <Footer language={language} />
        </>
    )
}

export default Home